// extracted by mini-css-extract-plugin
module.exports = {"box":"EventsList_box__mJE9m","title":"EventsList_title__3vIh5","date":"EventsList_date__dM4n0"};